<template>
  <el-dialog :title="title"
             :visible.sync="params.flag"
             v-dialogDrag
             :modal="false"
             :close-on-click-modal="false"
             :lock-scroll="false"
             :modal-append-to-body=false
             :append-to-body="false"
             ref="jsfxRef"
             width="50%"
             custom-class="hdsk"
  >
    <div slot="title" class="select-header">
      <span>{{title}}</span>
      <span>
          <span v-if="zjzSlideLiveDataResult && zjzSlideLiveDataResult.time && zjzSlideLiveDataResult.time.length > 0" class="update-time">
            更新时间：{{
              $moment(zjzSlideLiveDataResult.time[zjzSlideLiveDataResult.time.length -1]).format("YYYY-MM-DD HH:mm")
            }}
          </span>
        </span>
    </div>
    <div class="main">
      <div class="content">
        <div class="point-slide-live">
          <div class="point-slide-live-wrap">
            <div class="point-slide-live-list" ref="pointSlideLiveList">
              <div id="zjz-slielive-sc-chart"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import 'echarts/lib/component/markLine'
import echarts from '@/config/echarts'
import Vue from 'vue'
import {
  getScZjzSlideLiveOption,
  getSlideLiveOption,
  getZjzSlideLiveOption
} from '@/config/echarts/option/point-slide-live'
import { mapState } from 'vuex'

export default {
  components: { },
  props: ['params'],
  data () {
    return {
      rootFontSize: window.rootFontSize
    }
  },
  watch: {
    'params.flag': {
      handler (flag) {
        if (flag) {
          this.setZindex()
        }
      },
      immediate: true
    },
    zjzSlideLiveDataResult: {
      handler () {
        this.$nextTick(() => {
          this.getData()
        })
      },
      deep: true
    }
  },
  computed: {
    ...mapState('home', ['zjzSlideLiveDataResult']),
    title () {
      return this.zjzSlideLiveDataResult.pointName ? this.zjzSlideLiveDataResult.pointName + '-' + '过去24小时实况' : '过去24小时实况'
    }
  },
  mounted () {
    this.setZindex()
  },
  methods: {
    // 设置弹出框的zIndex
    setZindex () {
      this.$nextTick(() => {
        const el = this.$refs.jsfxRef
        let zIndex = JSON.parse(localStorage.getItem('dialogZIndex'))
        zIndex = zIndex * 1 + 1
        el.$el.style.zIndex = zIndex
        localStorage.setItem('dialogZIndex', JSON.stringify(zIndex))
      })
    },
    initEchart () {
      const idName = 'zjz-slielive-sc-chart'
      const charts = echarts.init(document.getElementById(idName))
      charts.setOption(getScZjzSlideLiveOption())
      this.charts = charts
      // 页面缩放
      window.onresize = () => {
        Vue.prototype.$rootFontSize = document.body.clientWidth / 1920 * 16
        document.getElementsByTagName('html')[0].style.fontSize = this.$rootFontSize + 'px'
        this.charts.resize()
      }
    },
    async getData () {
      console.log('zjzSlideLiveDataResult', this.zjzSlideLiveDataResult)
      if (!this.charts) {
        this.initEchart()
      }
      const temp = this.fixEmpty(this.zjzSlideLiveDataResult.t)
      const t1 = this.fixEmpty(this.zjzSlideLiveDataResult.t1)
      const t2 = this.fixEmpty(this.zjzSlideLiveDataResult.t2)
      const ph = this.fixEmpty(this.zjzSlideLiveDataResult.ph)
      const nh = this.fixEmpty(this.zjzSlideLiveDataResult.nh)
      const ddo = this.fixEmpty(this.zjzSlideLiveDataResult.ddo)
      const timAarr = this.zjzSlideLiveDataResult.time
      const timeStrArr = []
      for (let i = 0; i < timAarr.length; i++) {
        const time = this.$moment(timAarr[i]).format('HH:00')
        timeStrArr.push(time)
      }
      const option1 = getScZjzSlideLiveOption()
      option1.xAxis.data = timeStrArr
      option1.series[0].data = temp
      option1.series[1].data = t1
      option1.series[2].data = t2
      option1.series[3].data = ph
      option1.series[4].data = ddo
      option1.series[5].data = nh
      option1.yAxis[0].max = Math.floor(Math.max(...[...temp, ...t1, ...t2]) + 2)
      option1.yAxis[0].min = Math.floor(Math.min(...[...temp, ...t1, ...t2]) - 2)
      // option1.yAxis[0].min = option1.yAxis[0].min - 2
      // option1.yAxis[1].max = 100
      // if (option1.yAxis[1].max < 5) {
      //   option1.yAxis[1].max = 5.0
      // }
      // option1.yAxis[1].min = 0
      //
      // option1.yAxis[2].max = Math.floor(Math.max(...light) + 2)
      // option1.yAxis[2].min = Math.floor(Math.min(...winds) - 2 < 0 ? 0 : Math.min(...winds) - 2)
      this.charts.clear()
      console.log('option1', option1)
      this.charts.setOption(option1)
      this.$nextTick(() => {
        this.charts.resize()
      })
    },
    fixEmpty (values) {
      const result = []
      for (let i = 0; i < values.length; i++) {
        if (values[i] === 'null' || values[i] === null) {
          values[i] = '--'
        }
        result.push(values[i])
      }
      return values
    }
  }
}
</script>
<style lang="less" scoped>

.select-header {
  display: flex;
  justify-content: space-between;
  padding-right: 2.6vw;
  color: #fff;

  span:nth-child(1) {
    font-size: 0.94vw;
    font-weight: 600;
    color: #fff;
  }

  span:nth-child(2) {
    font-size: 0.73vw;
  }
}

/deep/ .el-dialog__wrapper {
  overflow: hidden;

  .el-dialog {
    pointer-events: auto;
  }
}

.content {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 1vw 1.04vw 0.56vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  border-radius: 0.63vw;
  width: 100%;
  height: 100%;
  //height: 30vh;

  .point-slide-live {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0vw;

    .point-slide-live-wrap {
      position: relative;
      // top: -2.04vw;
      width: 100%;
      margin-top: 0.52vw;
      height: calc(100% - 0.52vw);
      overflow: hidden;

      .point-slide-live-list {
        width: 100% !important;
        height: 100%;
        display: flex;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        transition: all 0.3s linear;

        .item {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          width: 5.58rem;

          span {
            font-size: 0.75rem;
            color: #FFF;
          }

          .des {
            font-size: 0.88rem;
            color: #FFF;
          }

          img {
            width: 2.25rem;
          }

          .chart {
            height: 90%;
          }

          .wind {
            color: #FFF;
          }
        }

        #zjz-slielive-sc-chart {
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          width: 100%;
        }
      }
    }

    .left-botton {
      width: 0.81rem;
      height: 1.88rem;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      left: 1.2rem;
      cursor: pointer;
    }

    .right-botton {
      width: 0.81rem;
      height: 1.88rem;
      background-size: contain;
      position: absolute;
      top: 50%;
      margin-top: -0.94rem;
      right: 1.2rem;
      cursor: pointer;
    }
  }

  .days-forecast {
    height: 100%;
    // padding: 8% 3% 0 2%;
    box-sizing: border-box;

    .days-forecast-list {
      display: flex;
      justify-content: space-between;
      height: 100%;
      position: relative;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 6.85rem;

        span {
          font-size: 0.75rem;
          color: #FFF;
        }

        font {
          font-size: 0.88rem;
          color: #FFF;
        }

        img {
          width: 2rem;
        }

        .chart {
          height: 50%;
        }
      }

      #high-low-temp-chart {
        position: absolute;
        left: 2.3rem;
        right: 2.3rem;
        top: 52%;
        height: 45%;
      }
    }
  }

  .publish-time {
    display: flex;
    align-items: center;
    position: absolute;
    right: 2.08vw;
    top: .8vw;;
    color: #FFF;
    font-size: 0.63vw;

    .el-icon-time {
      margin-right: 0.26vw;
    }
  }
}

</style>
